import { createFileRoute, redirect } from '@tanstack/react-router'

import { FOOD_SUPPORTED_COUNTRIES } from '@/lib/food/config'
import { countryAtom } from '@/lib/locale/country'

export const Route = createFileRoute('/_food')({
  component: Outlet,
  beforeLoad: ({context}) => {
    const currentCountry = context.store.get(countryAtom)
    if (!FOOD_SUPPORTED_COUNTRIES.includes(currentCountry)) {
      alert('Food & Delivery is only available in the US and Canada')
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- this is desired behavior
      throw redirect({
        to: '/',
      })
    }
  },
})
